<template>
    <div class="testStep">
        <div class="uk-padding " style="background: rgba(0, 0, 0, 0.9); ">
            <h1 class="uk-heading-line uk-text-center goldColor">Why FINCOR?</h1>
            <div class="uk-text-center">
                <small class="uk-align-center uk-light">Our clients choose us for many reasons, here are a few:</small>
            </div>
            <div class="uk-container uk-container-large">
                <div class="uk-child-width-1-2@m uk-child-width-1-3@l " uk-grid uk-scrollspy="cls: uk-animation-fade; target: .uk-card; delay: 500;">

                    <div>
                        <h3 class="uk-heading-divider goldColor">Management Team</h3>
                        <p class="silverColor">
                          FINCOR is led by Ronnie Dunn, a CPA with over 20 years
                          post-qualification and management experience in the
                          private and public sectors. He is assisted by Ms. Lidka
                          Scott, an Economist, and Mr. Numan Sabir, an ACCA
                          qualified accountant with over 10 years post
                          qualification experience.
                        </p>
                    </div>
                    <div >
                        <h3 class="uk-heading-divider goldColor">A track record of success</h3>
                        <p  class="silverColor">
                          FINCOR has successfully delivered services to the
                          private, public, and non-profit sectors since 2015.
                          Examples of our successful outcomes can be seen under
                          client stories and testimonials.
                        </p>
                    </div>
                    <div  class="silverColor">
                        <h3 class="uk-heading-divider goldColor">Our Company Strategy</h3>
                        <p  class="silverColor">
                            FINCOR offers superior financial management and advisory services to public and private organizations in the
                            Cayman Islands. We deliver value for money through personalized service, technology, and our team of competent,
                            motivated and professional individuals.
                        </p>
                    </div>

                </div>
                <br>
                <router-link to="/why-choose-fincor-services" class="uk-button uk-button-secondary uk-align-right goldColor uk-text-capitalize" >Learn More ..</router-link>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "whyFincor"
    }
</script>

<style scoped>
    .testStep{
        background-image: url('~@/assets/bg3.png');
        background-size: cover;

    }
    .goldColor{
        color: rgb(197,179,88)
    }
    .silverColor{
        color: silver;
    }
</style>